
























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import { contains } from 'ramda'
import { getModule } from 'vuex-module-decorators'
import firebase from 'firebase/app'
import MainMixin from '../mixins/MainMixin'

@Component({
  components: {
  },
})
export default class Login extends Mixins(MainMixin) {
  email: string = ''

  password: string = ''

  loading: boolean = false

  message: string = ''

  showPassword: boolean = false

  online:boolean = true

  get uid() {
    if (this.$store.getters.uid) {
      return this.$store.getters.uid
    } return null
  }

  async login(formRef: any) {
    this.message = ''
    // eslint-disable-next-line
    if ((this.$refs.loginform as Vue & { validate: () => boolean }).validate()) {
      this.loading = true
      try {
        const result = await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
        console.log('result here is: ', result)
        this.loading = false
      } catch (e) {
        if (e.code === 'auth/invalid-email') {
          this.message = `${this.email} is not a valid email address.`
        } else if (e.code === 'auth/user-not-found') {
          this.message = `No user found with the email: ${this.email}.`
        } else if (e.code === 'auth/wrong-password') {
          this.message = 'Incorrect Password'
        }
        this.loading = false
      }
    }
  }

  @Watch('uid', { immediate: true, deep: true })
  userLoggedIn(uid:string, old:any) {
    console.log('uid is: ', uid)
    if (uid) {
      const redirectQuery = this.$route.query.redirectUrl || undefined
      if (contains(redirectQuery, ['/location', undefined, '/login', '/check-login'])) {
        return this.$router.push('/location')
      } return this.$router.push(`/location?redirectQuery=${redirectQuery}`)
    } return true
  }
}
